import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReportEntity } from '@data';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';

import ReportIncidentForm from './ReportIncidentForm';

/** The entry form's Incident tab in a dialog of its own, for an entry that is already incident work. */
const ReportIncidentDialog = ({
  show,
  onHide,
  userId,
  report,
  against,
  prefill,
  onSubmit,
}: {
  show: boolean;
  onHide: () => void;
  userId?: string;
  report?: ReportEntity | null;
  against?: { productId: string; incidentId: string } | null;
  prefill?: { productId?: string; workday?: Date; today?: string } | null;
  onSubmit: (values: Partial<ReportEntity>) => Promise<unknown>;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={show} onOpenChange={next => !next && onHide()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{report ? t('reportIncident.editTitle') : t('reportIncident.title')}</DialogTitle>
        </DialogHeader>

        <ReportIncidentForm
          show={show}
          onHide={onHide}
          userId={userId}
          report={report}
          against={against}
          prefill={prefill}
          onSubmit={onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReportIncidentDialog;
